import { Pipe, PipeTransform } from '@angular/core';

import { REFERENTIEL_TYPE } from '../models/référentiel-type.enum';

@Pipe({
  name: 'convertReferentielTypeToString',
})
export class ConvertReferentielTypeToStringPipe implements PipeTransform {
  transform(value: REFERENTIEL_TYPE): string {
    switch (value) {
      case REFERENTIEL_TYPE.METIER:
        return 'Métier';
      case REFERENTIEL_TYPE.FORMATEUR:
        return 'Formateur';
      case REFERENTIEL_TYPE.SCIENCES_ET_CULTURE:
        return 'Sciences et culture';
      case REFERENTIEL_TYPE.COMPAGNONNIQUE:
        return 'Compagnonnique';
      case REFERENTIEL_TYPE.TRANSVERSE:
        return 'Transverse';
    }
  }
}
